import React, {useEffect, useState} from "react"
// MUI
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid2 as Grid,
    IconButton,
    TextField
} from "@mui/material";
import {CloseRounded, Save} from "@mui/icons-material";
// Ui
import {LanguageSelect} from "@/components/UI";
// Misc
import {languageCodeToName} from "@/utils";
// Tokens
import {packagingTokens as tk} from "@/theme/packagingTokens";

export default function AppEditorTranslationsDialog(props: any) {

    const {
        open, onClose,
        app, setApp,
        translation,
        t
    } = props

    const [localTranslation, setLocalTranslation] = useState<any>(null)

    useEffect(() => {
        if (!!translation) setLocalTranslation({
            ...translation,
            language: {
                code: translation.language,
                name: languageCodeToName(translation.language)
            }
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props])

    const handleSave = () => {
        if (!app) return
        let appTranslations = app.translations
        // Check if translation is already there
        let previousTranslation = appTranslations.filter((trans: any) => (!!trans.id && trans.id === localTranslation.id) || trans.language === localTranslation.language)

        if (previousTranslation[0]) {
            appTranslations.splice(appTranslations.findIndex((trans: any) => trans.id === localTranslation.id || trans.language === localTranslation.language) ,1)
            appTranslations.push({
                ...localTranslation,
                language: localTranslation.language.code
            })
            setApp({...app, translations: appTranslations})
        } else {
            appTranslations.push({
                ...localTranslation,
                language: localTranslation.language.code
            })
            setApp({...app, translations: appTranslations})
        }
        onClose()
    }

    // Display
    const renderTranslationForm = () => {
        return (
            <>
                <Grid size={12}>
                    <TextField
                        fullWidth
                        label={t("translation_title")}
                        value={localTranslation?.content.title}
                        onChange={(e) => setLocalTranslation({...localTranslation, content: {
                            ...localTranslation.content, title: e.target.value
                        }})}
                    />
                </Grid>
                <Grid size={12}>
                    <TextField
                        label={t("translation_disclaimer")}
                        fullWidth
                        value={localTranslation?.content.disclaimer}
                        onChange={(e) => setLocalTranslation({...localTranslation, content: {
                                ...localTranslation.content, disclaimer: e.target.value
                        }})}
                        multiline
                        rows={5}
                    />

                </Grid>
                <Grid size={12}>
                    <TextField
                        label={t("translation_accept")}
                        fullWidth
                        value={localTranslation?.content.accept}
                        onChange={(e) => setLocalTranslation({...localTranslation, content: {
                                ...localTranslation.content, accept: e.target.value
                        }})}
                    />

                </Grid>
                <Grid size={12}>
                    <TextField
                        label={t("translation_refuse")}
                        fullWidth
                        value={localTranslation?.content.refuse}
                        onChange={(e) => setLocalTranslation({...localTranslation, content: {
                                ...localTranslation.content, refuse: e.target.value
                        }})}
                    />

                </Grid>
                <Grid size={12}>
                    <LanguageSelect
                        language={localTranslation?.language}
                        setLanguage={(val: any) => setLocalTranslation({...localTranslation, language: val})}
                        {...{t}}
                    />
                </Grid>
            </>
        )
    }

    return (
        <>
            <Dialog open={open} onClose={onClose} maxWidth={"sm"} fullWidth>
                <DialogTitle sx={{display: "flex", alignItems: "center", justifyContent: "space-between", pr: 1.5}}>
                    <Box component={"span"} sx={{fontSize: "18px", fontWeight: 600}}>
                        {t("edit_translation")}
                    </Box>
                    <IconButton onClick={onClose} aria-label={t("common:close")} sx={{color: tk.color.textTertiary}}>
                        <CloseRounded />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Grid container justifyContent={"center"} spacing={2} sx={{ mt: 0.5, mb: 1 }}>
                        {renderTranslationForm()}
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2.5 }}>
                    <Button onClick={onClose} sx={{ textTransform: "none", color: tk.color.textSecondary }}>
                        {t("common:cancel")}
                    </Button>
                    <Button
                        startIcon={<Save sx={{fontSize: 16}} />}
                        variant={"contained"}
                        disableElevation
                        onClick={() => handleSave()}
                        sx={{ textTransform: "none", fontWeight: 600, borderRadius: tk.radius.sm, px: 2 }}
                    >
                        {t("common:save")}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )

}